// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"84759876","788":"ac518b92"}[chunkId] + ".chunk.css";
};